import { siteConfig } from "../../content/site";

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="section-shell site-footer__inner">
        <div>
          <strong>{siteConfig.businessName}</strong>
          <p>{siteConfig.address}</p>
          <a href={siteConfig.phoneHref}>{siteConfig.phoneDisplay}</a>
        </div>
        <div className="site-footer__links">
          <a href="/">ホーム</a>
          <a href="/privacy">プライバシーポリシー</a>
        </div>
        <small>© 2026 {siteConfig.businessName}</small>
      </div>
    </footer>
  );
}
